import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Grid, Paper } from '@mui/material';

const buttonValues = [
  ['7', '8', '9', '/'],
  ['4', '5', '6', '*'],
  ['1', '2', '3', '-'],
  ['0', '.', '=', '+']
];

export default function CalculatorApp() {
  const [display, setDisplay] = useState('');
  const [result, setResult] = useState('');

  const handleClick = (val) => {
    if (val === '=') {
      try {
        // eslint-disable-next-line no-eval
        const res = eval(display);
        setResult(res);
        setDisplay(res.toString());
      } catch (e) {
        setResult('Erreur');
      }
    } else {
      setDisplay(display + val);
      setResult('');
    }
  };

  const handleClear = () => {
    setDisplay('');
    setResult('');
  };

  return (
    <Paper elevation={4} sx={{ p: 3, maxWidth: 320, margin: 'auto' }}>
      <Typography variant="h6" align="center" gutterBottom>Calculatrice</Typography>
      <TextField
        value={display}
        variant="outlined"
        fullWidth
        margin="dense"
        inputProps={{ style: { textAlign: 'right', fontSize: 24 } }}
        disabled
      />
      <Typography variant="subtitle1" align="right" color="primary" gutterBottom>
        {result}
      </Typography>
      <Grid container spacing={1}>
        {buttonValues.flat().map((val, idx) => (
          <Grid item xs={3} key={idx}>
            <Button
              variant="contained"
              color={['/', '*', '-', '+', '='].includes(val) ? 'secondary' : 'primary'}
              fullWidth
              sx={{ fontSize: 20, minHeight: 48 }}
              onClick={() => handleClick(val)}
            >
              {val}
            </Button>
          </Grid>
        ))}
        <Grid item xs={6}>
          <Button variant="outlined" color="error" fullWidth sx={{ minHeight: 48 }} onClick={handleClear}>
            C
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
}
